/*
    Список перечислений для программных модулей
*/

/* 
    Тип программного модуля
*/
export enum ConfigType {
  OrTahoModule = 'dtcp-tachometer-modules', //Тахометр и расходомерм
  OrTemperatureSourceModule = 'or-temperature-source-module', //Датчик температуры
  OrEnergyModule = 'or-energy-module', //Датчик тока
  OrAccelerometerModule = 'or-accelerometer-module', //Акселерометр
  OrCrmModule = 'or-crm-module', //Тахометр по датчику тока
  OrHeaterMonitorModule = 'or-heater-monitor-module', //Модуль определения статуса работы узла
  OrCleanStorageModule = 'or-clean-storage-module', //Модуль очистки БД
}

/* Тип программного модуля (Новый) */

export enum PModuleType {
  DtcpTahoModule = 'DtcpTahoModule',
  CrmModule = 'CrmModule',
  DtcpServerModule = 'DtcpServerModule',
  DtcpEnergyModule = 'DtcpEnergyModule',
  DtcpTemperatureModule = 'DtcpTemperatureModule',
  DtcpAccelerometerModule = 'DtcpAccelerometerModule',
  HeaterMonitorModule = 'HeaterMonitorModule',
  BearingControlModule = 'BearingControlModule', // Модуль дефектов подшипников, пока нереализован
  CleanStorageModule = 'CleanStorageModule', // Модуль очистки хранилища БД
  ServerMonitorModule = 'ServerMonitorModule', // модуль определения состояния сервера
  PingerModule = 'PingerModule', // Модуль мониторинга сетевого оборудования
  DtcpEmulatorModule = 'DtcpEmulatorModule', // Модуль эмулятора сервера сбора данных
  StatsCollectorModule = 'StatsCollectorModule', // Модуль сбора статистик с ПМ датчиков
  SignalTrendModule = 'SignalTrendModule', // Задача анализа тренда сигнала
  SignalTrendServerModule = 'SignalTrendModule', // Модуль анализа тренда сигнала
  MonitorStatesTasks = 'MonitorStatesTasks', // Задача определения состояния по датчикам
  MonitorBoundaryTasks = 'MonitorBoundaryTasks', // Задача определения по границам
  MonitorChildTasks = 'MonitorChildTasks', // Задача определения по дочерним задачам
  BearingTasks = 'BearingTasks', // Задача определения дефекта подшипника
  SignalTrendTasks = 'SignalTrendTasks', // Задача мониторинга трендов
}

/*
    Категория модуля, возвращается сервером в поле regnum_type справочника module_types
*/
export enum RegnumType {
  ProgramModule = 'ProgramModule',
  SensorModule = 'SensorModule',
  TaskModule = 'TaskModule',
  EventModule = 'EventModule',
  NodeModule = 'NodeModule',
}
